import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from '@shopify/polaris';
import de from '@shopify/polaris/locales/de.json';
import en from '@shopify/polaris/locales/en.json';
import App from './App';
import { setLocale } from './i18n';

function detectLocale(): string {
  const shopify = (window as any).shopify;
  const locale = shopify?.config?.locale || shopify?.locale || shopify?.i18n?.currentLocale || navigator.language || 'de';
  return locale.split('-')[0].toLowerCase();
}

function Root() {
  const [locale, setDetectedLocale] = useState('de');

  useEffect(() => {
    const detected = detectLocale();
    setLocale(detected);
    setDetectedLocale(detected);
    console.log('[InvoicePilot] Detected locale:', detected);
  }, []);

  const polarisI18n = locale.startsWith('en') ? en : de;

  return (
    <AppProvider i18n={polarisI18n}>
      <App />
    </AppProvider>
  );
}

const root = createRoot(document.getElementById('app')!);

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
